export default {
  organizations: [],
  total: 0,
  limit: 5,
  current_page: 1,
  organization: null,
  collections: [],
  templates: []
}